import { environment } from '../../../environments/environment';

/**
 * When true, request/response bodies matching path rules use AES-256-GCM.
 * Toggle via environment — no code change to disable in production.
 */
export const payloadEncryptionConfig = {
  get enabled(): boolean {
    return !!environment.payloadEncryptionEnabled;
  },
  /**
   * Only URLs matching at least one pattern get encrypted (substring match).
   * Example: '/api/', '/auth/'
   */
  pathPatterns: ['/api/', '/auth/'],
  /**
   * URLs containing any of these are never encrypted (e.g. public validate, health).
   */
  excludePatterns: ['auth/session/validate', 'agentic-ai/session/validate'],
  /** HTTP methods that may carry an encrypted JSON body */
  encryptMethods: ['POST', 'PUT', 'PATCH'] as const,
};

export function shouldEncryptForUrl(url: string): boolean {
  if (!payloadEncryptionConfig.enabled) return false;
  if (payloadEncryptionConfig.excludePatterns.some((p) => url.includes(p))) {
    return false;
  }
  return payloadEncryptionConfig.pathPatterns.some((p) => url.includes(p));
}
